export var HOURS = new Array(24 + 1).join('0').split('')
export var TWELVE_HOURS = new Array(12 + 1).join('0').split('')
export var MINUTES = new Array(60 + 1).join('0').split('')

